import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminClinicSwitchPage } from './admin-clinic-switch';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    AdminClinicSwitchPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminClinicSwitchPage),
    DirectivesModule
  ],
})
export class AdminClinicSwitchPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-clinic-switch/admin-clinic-switch.module.ts